import * as React from "react";
import { Icon, Position, Tooltip } from "@customer-tools-web/component-ui/lib";
import { useI18N } from "@customer-tools-web/component-i18n";
import { TooltipContent } from "./Tooltip.style";

type Props = {
  iconColor?: string;
};
export const PremiumBalanceTooltip = (props: Props) => {
  const { t } = useI18N();
  const { iconColor = "#ffffff" } = props;
  return (
    <Tooltip
      trigger={"click"}
      position={Position.BOTTOM}
      closable={false}
      customCss={{
        wrapper: {
          maxWidth: 340,
        },
        arrow: {
          color: "#353F47",
        },
      }}
      content={
        <TooltipContent>
          {t("specialistSelfServe.premiumUpgradeTooltip")}
        </TooltipContent>
      }
    >
      <Icon type={"info-sign-lg"} color={iconColor} cursor={"pointer"} />
    </Tooltip>
  );
};
